/* (ignored) */


//////////////////
// WEBPACK FOOTER
// canvas (ignored)
// module id = 493
// module chunks = 0